<template>
    <!-- 课程管理 -->
    <div class="course">
        <p class="font-medium font-size16 title">课程管理</p>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-plus"
                   @click.stop="handleCreateCourse"
                   style="float: left">创建课程
        </el-button>
        <search-form :search-form.sync="searchForm" style="float: right" @search="handleSearch"/>
        <el-table class="clearfix" size="large"
                  border highlight-current-row
                  stripe :data="tableList">
            <el-table-column label="课程名称" prop="SourceName" align="center" min-width="160" show-overflow-tooltip/>
            <el-table-column label="类型" prop="SourceType" align="center"
                             :formatter="(row, column, val) => PROJECT_TYPE_OPTIONS[val]"/>
            <el-table-column label="所属分类" prop="ClassName" align="center" min-width="120"/>
            <el-table-column label="状态" prop="SourceState" align="center"
                             :formatter="(row, column, val) => SOURCE_STATE[val]"/>
            <el-table-column label="开始时间" prop="StartTime" align="center" min-width="160"/>
            <el-table-column label="结束时间" prop="EndTime" align="center" min-width="160"/>
            <el-table-column label="创建人" prop="UserName" align="center"/>
            <el-table-column label="操作" prop="actions" min-width="230" align="center">
                <template v-slot="{ row }">
                    <el-row type="flex" align="middle" justify="center">
                        <el-button type="info" @click.stop="handleEdit(row)" plain size="mini">编辑</el-button>
                        <el-button type="primary"
                                   size="mini"
                                   @click.stop="handleDetail(row)"
                                   style="margin-right: 10px">详情
                        </el-button>
                        <el-button :type="parseInt(row.SourceState) === 0 ? 'success' : 'danger'"
                                   size="mini"
                                   @click.stop="changeState(parseInt(row.SourceState) === 0 ? 1 : 0, row)"
                                   plain>{{parseInt(row.SourceState) === 0 ? "启用" : "禁用"}}</el-button>
                    </el-row>
                </template>
            </el-table-column>
        </el-table>
        <pagination :p-size.sync="pagination.pageSize"
                    :page-no.sync="pagination.page"
                    @change="getSourceList"
                    :total="pagination.total"/>
    </div>
</template>

<script>
import { getIntiSearchForm, SOURCE_STATE, PROJECT_TYPE_OPTIONS } from "./config"
import { getSourceList, enableCourse } from "@/api/manage"
import SearchForm from "./cpns/SearchForm"
import Pagination from "@/components/Pagination";

export default {
    name: "course",
    components: {
        Pagination,
        SearchForm
    },
    data() {
        return {
            searchForm: getIntiSearchForm(),
            pagination: {
                page: 1,
                pageSize: 10,
                total: 10
            },
            courseState: 0,
            tableList: [],
            SOURCE_STATE,
            PROJECT_TYPE_OPTIONS
        }
    },
    created() {
        this.getSourceList()
    },
    methods: {
        // 获取课程列表
        getSourceList() {
            const {
                page,
                pageSize
            } = this.pagination
            getSourceList({
                pageIndex: page,
                pageSize,
                ...this.searchForm
            }).then(res => {
                this.tableList = res.data
                this.pagination.total = res.count
            }).catch(e => {
                this.pagination.page = 1
                this.tableList = []
                this.$message.error(e.message || "获取列表失败")
            })
        },
        // 处理搜索
        handleSearch() {
            this.pagination.page = 1
            this.getSourceList()
        },
        changeState(val, row) {
            enableCourse([row.SourceId], parseInt(val)).then(res => {
                this.$set(row, "SourceState", val)
                this.$message.success(parseInt(val) === 0 ? "禁用成功" : "启用成功")
            })
        },
        // 创建课程
        handleCreateCourse() {
            this.$router.push(this.$route.path + "/add")
        },
        // 处理编辑
        handleEdit(item) {
            this.$router.push({
                path: this.$route.path + "/add",
                query: {
                    SourceId: item.SourceId
                }
            })
        },
        handleDetail(item) {
            this.$router.push({
                path: this.$route.path + "/detail",
                query: {
                    SourceId: item.SourceId
                }
            })

        }
    },
}
</script>

<style scoped lang="less">
.title {
    margin-bottom: 30px;
}

.course {
    padding: 20px 40px;
    font-size: 16px;
}
</style>
